import { Component, Input, Inject, NgModuleRef } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthServiceInterface } from '../../services/auth/auth-service.interface';
import { IUnsecuredService } from '../../services/unsecured/unsecured-service.interface';
import { Auth2FAUnsecuredModal } from '../../modals/2fa-unsecured/2fa-unsecured.modal';
import { IMODALS_SERVICE, IModalsService } from '@platform500services/p500-ui-kit';
import { RbacServiceInterface } from '../../services/rbac/rbac-service.interface';
import { RbacPermissionsConstant } from '../../services/rbac/rbac-permissions.constant';

@Component({
  selector: 'gtd-profile-menu',
  templateUrl: './profile-menu.component.html',
})
export class ProfileMenuComponent {
  @Input() cssClass = '';
  public userID: number;
  public unsecuredModeControl = new UntypedFormControl(false);
  public RbacPermissionsConstant = RbacPermissionsConstant;

  constructor(
    @Inject('AuthServiceInterface') public authService: AuthServiceInterface,
    @Inject('IUnsecuredService') public unsecuredService: IUnsecuredService,
    @Inject(IMODALS_SERVICE) private modalsService: IModalsService,
    @Inject('RbacServiceInterface') public rbacService: RbacServiceInterface,
    private moduleRef: NgModuleRef<any>,
    private router: Router
  ) {
    this.unsecuredService.getUnsecuredStatus().subscribe((status) => {
      this.unsecuredModeControl.setValue(status.isUnsecured, { emitEvent: false });
    });
    this.unsecuredModeControl.valueChanges.subscribe((value) => {
      if (value) {
        this.modalsService.open(Auth2FAUnsecuredModal, {}, this.moduleRef);
        this.unsecuredModeControl.setValue(false);
      } else {
        this.unsecuredService.leave().subscribe((response) => {
          if (response.data && response.data.user) {
            this.unsecuredService.setUnsecuredStatus(false);
          }
        });
      }
    });

    this.authService.getUser().subscribe((user) => (this.userID = user.id));
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/auth/signin'], { queryParams: { logout: true } });
  }

  editProfile(): void {
    this.router.navigate(['/auth/signin'], { queryParams: { logout: true } });
  }
}
